import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {CRUD_PERSONAL_VERIFIED_BY, CRUD_PERSONAL_EMPLOYEE_FETCH_BY_ID,CRUD_PERSONAL_IDENTIFICATION,CRUD_ORGANIZATION_LEGAL_ENTITY, CRUD_PERSONAL_EMPLOYEE_MAIN, HCM_PERSONAL_DOWNLOAD_DATA , HCM_PERSONAL_UPLOAD_DATA } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addPersonalEmployee",
    method: "post",
    url: CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "message",
  },
  {
    name: "getPersonalEmployee",
    method: "get",
    url: CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "data",
  },
  {
    name: "getPersonalLegalEntity",
    method: "get",
    url: CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "data",
  },
   {
    name: "getPersonalEmployeeById",
    method: "get",
    url: CRUD_PERSONAL_EMPLOYEE_FETCH_BY_ID,
    stateKey: "details",
  },
  {
    name: "getPersonalIdentification",
    method: "get",
    url: CRUD_PERSONAL_IDENTIFICATION,
    stateKey: "identificationData",
  },
   {
    name: "getOrganizationLegalEntity",
    method: "get",
    url:  CRUD_ORGANIZATION_LEGAL_ENTITY,
    stateKey: "organizationLegalEntityData",
  },
   
  {
    name: "getPersonalVerifiedBy",
    method: "get",
    url:  CRUD_PERSONAL_VERIFIED_BY,
    stateKey: "verifiedByData",
  },
  {
    name: "updatePersonalEmployee",
    method: "put",
    url: CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "message",
  },
   {
    name: "updatePersonalIdentification",
    method: "post",
    url:  CRUD_PERSONAL_IDENTIFICATION,
    stateKey: "message",
  },
  {
    name: "deletePersonalEmployee",
    method: "delete",
    url: CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "message",
  },
   {
    name: "deletePersonalIdentification",
    method: "delete",
    url:CRUD_PERSONAL_IDENTIFICATION,
    stateKey: "message",
  },
  {
    name: "getPersonalEmployeeDetailsById",
    method: "get",
    url:CRUD_PERSONAL_EMPLOYEE_MAIN,
    stateKey: "details",
  },
  // {
  //   name: "uploadPersonalEmployeeFile",
  //   method: "post",
  //   url: HCM_PERSONAL_UPLOAD_DATA,
  //   stateKey: "message",
  // },
];
export const uploadPersonalEmployeeFile = createAsyncThunk(
  "prospect/uploadPersonalEmployeeFile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(HCM_PERSONAL_UPLOAD_DATA, formData, {
        withCredentials: true,
        responseType: "blob",
      });

     
      
      const contentType = res.headers["content-type"];

      // Backend returned failed Excel
      if (
        contentType?.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const url = globalThis.URL.createObjectURL(
          new Blob([res.data])
        );


        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", "FailedPersonalEmployees.xlsx");

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        globalThis.URL.revokeObjectURL(url);

        return {
          message: "Some prospects failed. Failed records have been downloaded.",
        };
      }

      // Backend returned JSON response
      const text = await res.data.text();
      const data = JSON.parse(text);

      return data;
    } catch (err) {
      let errorData = err?.response?.data;

      // Error response can also be a Blob
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();
          errorData = JSON.parse(text);
        } catch {
          // Keep original errorData if it is not JSON
        }
      }

      return rejectWithValue(errorData);
    }
  }
);
export const downloadPersonalEmployeeData = createAsyncThunk(
  "prospect/downloadPersonalEmployeeData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(HCM_PERSONAL_DOWNLOAD_DATA , {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          
          link.setAttribute("download", "PersonalEmployees.xlsx");
          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: {},
    identificationData:[],
    verifiedByData:[],
    organizationLegalEntityData:[],
     personalLegalEntityData:[],
    additionalData: [],
    orgEntityData:null
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
     setSelectedOrgData: (state, action) => {
      state.orgEntityData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadPersonalEmployeeData.pending]: (state) => {
      state.loading = true;
    },

    [downloadPersonalEmployeeData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadPersonalEmployeeData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [uploadPersonalEmployeeFile.pending]: (state) => {
      state.loading = true;
    },

    [uploadPersonalEmployeeFile.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },

    [uploadPersonalEmployeeFile.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage =
        action?.payload?.message ||
        action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospect",
  apiConfig,
  customReducers,
);
const prospectSlice = slice;

// Export the slice's reducer
export default prospectSlice.reducer;

// Export thunks
export const {
  addPersonalEmployee,
  getPersonalEmployee,
  updatePersonalEmployee,
  deletePersonalEmployee,
  getPersonalEmployeeDetailsById,
  getPersonalIdentification,
  updatePersonalIdentification,
  getOrganizationLegalEntity,
 getPersonalEmployeeById,
 getPersonalVerifiedBy,
 getPersonalLegalEntity,
 deletePersonalIdentification,
  // uploadPersonalEmployeeFile
} = thunks;

// Export actions
export const { rowSelect,setSelectedOrgData } = actions;

